import React from 'react';
import { Container } from 'react-bootstrap';
// import background from '../components/assets/Impressum.jpg'; style={{ backgroundImage: `url(${background})`, height:'100vh', backgroundSize: 'cover', backgroundRepeat: 'no-repeat', fontSize:'20px',}}

const Impressum = (props) => {
    return (
      <Container className='starter-template' >
        <h2>Impressum</h2>
        <h3>Verantwortlich:</h3>
        <h4>Kliniken Dr. Vötisch GmbH</h4>
        <p>Herderstr. 10<br />
        97980 Bad Mergentheim</p>
        <p>Tel.: +49 7931 499-0<br/>
        Fax: +49 7931 44607<br/>
        <a href='mailto:info@kliniken-dr-voetisch.de'>info@kliniken-dr-voetisch.de</a><br/>
        <a href='https://www.kliniken-dr-voetisch.de'>www.kliniken-dr-voetisch.de</a></p>
        <h4>Vertretungsberechtigte Geschäftsführerin:</h4>
        <p>Barbara Dosch-Funk</p>
        <h4>Registergericht:</h4>
        <p>Amtsgericht Ulm</p>
        <h4>Registernummer:</h4>
        <p>HRB 680137</p>
        <h4>USt.-IdNr.</h4>
        <p>DE 144752309</p>
        <h4>Konzession:</h4>
        <p>nach §30 GewO</p>
        <h4>Konzessionsbehörde:</h4>
        <p>Stadt Bad Mergentheim</p>
        <p><a href='https://www.kliniken-dr-voetisch.de/datenschutzerklaerung'>Informationen zum Datenschutz</a></p>
      </Container>
    )
}

export default Impressum;